/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveHackyPool,
  ICurveHackyPoolInterface,
} from "../ICurveHackyPool";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256[8]",
        name: "_amounts",
        type: "uint256[8]",
      },
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256[2]",
        name: "_amounts",
        type: "uint256[2]",
      },
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256[7]",
        name: "_amounts",
        type: "uint256[7]",
      },
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256[6]",
        name: "_amounts",
        type: "uint256[6]",
      },
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256[4]",
        name: "_amounts",
        type: "uint256[4]",
      },
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256[5]",
        name: "_amounts",
        type: "uint256[5]",
      },
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256[3]",
        name: "_amounts",
        type: "uint256[3]",
      },
    ],
    name: "remove_liquidity",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurveHackyPool__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveHackyPoolInterface {
    return new utils.Interface(_abi) as ICurveHackyPoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveHackyPool {
    return new Contract(address, _abi, signerOrProvider) as ICurveHackyPool;
  }
}
